<template>
  <div class="nuttrema-sidebar-menu-notice">
    <div class="nuttrema-sidebar-menu-notice__top">
      <slot name="top">
        <div class="nuttrema-sidebar-menu-notice__logo">
          <span>
            <img src="~assets/images/dc-logo-small-gray.svg"/>
          </span>
        </div>
      </slot>
    </div>
    <div class="nuttrema-sidebar-menu-notice__center">
      <slot name="center"></slot>
    </div>
    <div class="nuttrema-sidebar-menu-notice__bottom">
      <slot name="bottom"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'nuttrema-sidebar-menu-notice',
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
  .nuttrema-sidebar-menu-notice {
    flex-grow: 1;
    display: flex;
    align-self: stretch;
    flex-direction: column;
    justify-content: space-between;

    background-color: rgba(#f6ce00, 0.5);

    &.is-blue {
      background-color: rgba(#00bcd4, 0.5);
    }

    .nuttrema-sidebar-menu-notice__top {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .nuttrema-sidebar-menu-notice__center {
      flex-grow: 1;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }

    .nuttrema-sidebar-menu-notice__bottom {
      display: flex;
      flex-direction: column;
    }

    .nuttrema-sidebar-menu-notice__logo {
      z-index: 1;
      flex-grow: 1;
      display: flex;
      padding: 1em 0;
      align-items: center;
      justify-content: center;
      > span {
        width: 25%;
        i {
          width: 100%;
        }
      }
    }

    .nuttrema-sidebar-menu-notice__text {
      margin: 1em;
      display: flex;
      flex-flow: column;

      .text--title {
        font-weight: 700;
        font-size: 1.75rem;
        font-family: 'Asap';
        line-height: 1.75rem;
        margin-bottom: 0.25em;
      }

      /deep/ div {
        margin-bottom: 0.5em;

        p {
          line-height: 1.35;
        }

        &.text--subtitle {
          p {
            font-weight: 500;
          }
        }

        &.text--notice {
          margin-top: 2em;
          p {
            // color: gray;
            font-size: 0.9em;
          }
        }

        &.text--link {
          margin-top: 1em;
          line-height: 1.25;
          a {
            color: #353535;
            font-size: 0.85em;
            text-decoration: underline;
            &:hover, &:focus {
              color: #000;
            }
          }
        }
      }
    }

    .nuttrema-sidebar-menu-notice__bg {
      .image--paper-plane-fly {
        padding-right: 15%;
      }
      .image--dc-ballon-sun-cloud {
        padding: 0 1em;
      }
    }

    &.is-grey-storm-clouds {
      background-color: rgba(gray, 0.5);
      .nuttrema-sidebar-menu-notice__bg {
        display: flex;
        flex-grow: 1;
        align-self: stretch;

        background-image: url(~assets/images/grey-storm-clouds.svg);
        background-size: 100% auto;
        background-repeat: no-repeat;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/ui/panels/nuttrema-sidebar-menu-notice.vue